<template>
  <mdb-modal :show="show" @close="close()">
    <mdb-modal-header class="aqua-gradient">
      <mdb-modal-title>{{ event ? 'Edit' : 'Create' }} Event</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body class="overflow-hidden d-flex">
      <mdb-container>
        <mdb-select
          outline
          search
          :small="invalid.type ? 'Please, select event type' : null"
          :disabled="!!this.event"
          class="mt-1 mb-0"
          label="Event Type"
          v-model="eventTypes"
          @getValue="typeChange($event)"
        />
<!--        <bridge8-autocomplete-->
<!--          :small="invalid.type ? 'Please, select event type' : null"-->
<!--          :disabled="!!this.event"-->
<!--          outline-->
<!--          class="mt-1 mb-0"-->
<!--          label="Event Type"-->
<!--          required-->
<!--          null-value-string="Select type"-->
<!--          :min-chars-to-search="0"-->
<!--          :is-object-data="true"-->
<!--          :filter-required="true"-->
<!--          :data="eventTypes"-->
<!--          :search-string="eventTypeSearchString"-->
<!--          @blur="validate('type')"-->
<!--          @change="typeChange($event)"-->
<!--        />-->
        <hr/>
        <div class="d-flex flex-row justify-content-around">
          <div class="text-left">
            <label for="start-datetime">Start *</label><br/>
            <datetime
              class="mr-3"
              type="datetime"
              title="Start"
              input-id="start-datetime"
              format="yyyy-MM-dd HH:mm"
              v-model="start"
            />
          </div>
          <div class="text-left">
            <label for="end-datetime">End{{ (type && type.endRequired) ? ' *' : '' }}</label><br/>
            <datetime
              type="datetime"
              title="End"
              input-id="end-datetime"
              format="yyyy-MM-dd HH:mm"
              v-model="end"
            />
          </div>
        </div>
        <hr v-if="type && type.properties.length" />
        <hr />
        <template v-if="!!type" v-for="(propData, propKey) in (type ? type.properties : null) || {}">
          <mdb-input
            v-if="propData.type === 'STRING'"
            :small="invalid.properties.includes(propKey) ? 'This field is required' : null"
            outline
            :key="`prop-input-${propKey}`"
            :label="`${propData.label}${propData.required ? ' *' : ''}`"
            v-model="properties[propKey]"
            @blur="validate(propKey)"
            @change="setProperty(propKey, $event)"
          />
          <mdb-input
            v-else-if="propData.type === 'TEXT'"
            :small="invalid.properties.includes(propKey) ? 'This field is required' : null"
            type="textarea"
            outline
            :rows="4"
            :key="`prop-input-${propKey}`"
            :label="`${propData.label}${propData.required ? ' *' : ''}`"
            v-model="properties[propKey]"
            @blur="validate(propKey)"
            @change="setProperty(propKey, $event)"
          />
          <mdb-input
            v-else-if="propData.type === 'NUMBER'"
            :small="invalid.properties.includes(propKey) ? 'This field is required' : null"
            type="number"
            outline
            :key="`prop-input-${propKey}`"
            :label="`${propData.label}${propData.required ? ' *' : ''}`"
            v-model="properties[propKey]"
            @blur="validate(propKey)"
            @change="setProperty(propKey, $event)"
          />
        </template>
      </mdb-container>
    </mdb-modal-body>
    <mdb-modal-footer>
      <mdb-btn
        rounded
        size="sm"
        gradient="aqua"
        @click.native="close(true)"
        title="Save event"
      >Save</mdb-btn>
      <mdb-btn
        rounded
        size="sm"
        gradient="sunny-morning"
        @click.native="close()"
        title="Dismiss"
      >Cancel</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbContainer,
  mdbInput,
  mdbTextarea,
  mdbDatePicker2,
  mdbTimePicker,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbSelect,
  mdbBtn
} from 'mdbvue'
import { mapActions } from 'vuex'
import {errorCatch, formatDT2} from '../utils'
import {formatDate} from '@fullcalendar/core'
import {Datetime} from 'vue-datetime'

import 'vue-datetime/dist/vue-datetime.css'

export default {
  name: 'EventEditModal',
  data () {
    return {
      show: false,
      start: null,
      end: null,
      type: null,
      callback: ({start, end, code}) => { console.log('Start:', start, 'End:', end, 'Code', code) },
      event: null,
      eventTypes: [],
      internalProperties: {},
      invalid: {
        type: false,
        start: false,
        end: false,
        properties: []
      }
    }
  },
  props: {
    allEventTypes: {
      type: Array,
      required: true
    }
  },
  computed: {
    properties: {
      get () {
        const obj = {}
        Object.keys(this.type.properties).forEach(name => {
          obj[name] = this.internalProperties[name] || null
        })
        return obj
      }
    }
  },
  methods: {
    ...mapActions(['apiGetEvent']),
    setProperty (propKey, value) {
      this.internalProperties[propKey] = value
    },
    typeChange (typeCode) {
      this.type = this.allEventTypes.find(et => et.code === typeCode) || console.warn('No suitable eventType found!')
      this.validate('type')
    },
    validate (name = null) {
      if ([null, 'type'].includes(name)) this.invalid.type = !this.type
      if ([null, 'start'].includes(name)) this.invalid.start = !this.start
      if ([null, 'end'].includes(name)) this.invalid.end = (this.type && this.type.endRequired) ? !this.end : false
      if (name === null && this.type) {
        Object.keys(this.type.properties).forEach(propKey => {
          if (this.type.properties[propKey].required) {
            if (!this.properties[propKey]) {
              this.invalid.properties.push(propKey)
            } else {
              this.invalid.properties.filter(prop => prop !== propKey)
            }
          }
        })
      }
      if (![null, 'type', 'start', 'end'].includes(name) && this.type) {
        if (this.type.properties[name].required) {
          if (!this.properties[name]) {
            this.invalid.properties.push(name)
          } else {
            this.invalid.properties.filter(prop => prop !== name)
          }
        }
      }
    },
    checkValidity () {
      return !this.invalid.type && !this.invalid.start && !this.invalid.end && this.invalid.properties.length === 0
    },
    formatDateTime (obj) {
      return formatDate(obj, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        meridiem: false,
        omitCommas: true
      })
    },
    close (submit = false) {
      if (submit) {
        this.validate()
        if (this.checkValidity()) {
          this.callback(Object.assign(
            {start: this.start, end: this.end, code: this.type.code, properties: this.properties},
            this.event ? {uuid: this.event.id} : {}
          ))
        } else {
          return
        }
      }
      this.show = false
      this.start = null
      this.end = null
      this.type = null
      this.event = null
      this.internalProperties = {}
      this.callback = ({start, end, code}) => { console.log('Start:', start, 'End:', end, 'Code', code) }
    },
    calculateEventTypes () {
      this.eventTypes = this.allEventTypes.filter(et => et.allowCreate).map(et => {
        return {
          text: et.name,
          value: et.code,
          selected: et.code === (this.type ? this.type.code : null)
        }
      })
    }
  },
  mounted () {
    this.$bus.$on('modal-event-edit', ({event, callback}) => {
      this.event = event
      this.callback = callback
      this.show = true
    })
  },
  watch: {
    type () {
      if (this.type) {
        Object.keys(this.type.properties).forEach(propKey => {
          if (!this.internalProperties[propKey]) {
            this.internalProperties[propKey] = null
          }
        })
      } else {
        this.internalProperties = {}
      }
    },
    event () {
      if (this.event) {
        this.apiGetEvent(this.event.id)
          .then(data => {
            this.type = this.allEventTypes.find(et => et.code === data.type) || console.warn('No suitable eventType found!')
            this.start = formatDT2(data.start)
            this.end = formatDT2(data.end)
            this.calculateEventTypes()
            // TODO: Very strange behaviour
            this.internalProperties = data.properties
          })
          .catch(errorCatch('Get Event failed!', this))
      } else {
        this.type = null
        this.calculateEventTypes()
      }
    }
  },
  beforeDestroy () {
    this.$bus.$off('modal-event-edit')
  },
  components: {
    mdbContainer,
    mdbInput,
    mdbTextarea,
    mdbSelect,
    mdbDatePicker2,
    mdbTimePicker,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    Datetime
  }
}
</script>

<style lang="sass">
.modal-body
  height: 50vh
</style>



// WEBPACK FOOTER //
// src/components/EventEditModal.vue